import React from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { Button } from 'msp-components'
import type { FieldsConfiguration } from 'msp-components'

const messages = defineMessages({
  reviewHeadline: {
    id: 'cancellation_form.review.headline',
    defaultMessage: 'Confirm cancellation'
  },
  reviewText: {
    id: 'cancellation_form.review.text',
    defaultMessage:
      'Please review your information. Clicking "Confirm cancellation" submits your withdrawal to us.'
  },
  confirm: {
    id: 'cancellation_form.button.confirm',
    defaultMessage: 'Confirm cancellation'
  },
  edit: {
    id: 'cancellation_form.button.edit',
    defaultMessage: 'Edit'
  },
  submissionFailed: {
    id: 'cancellation_form.error.submission_failed',
    defaultMessage:
      'Your cancellation could not be submitted. Please try again.'
  }
})

const ReviewRow = ({
  label,
  value
}: {
  label: React.ReactNode
  value: string
}) => (
  <div className='flex flex-col'>
    <dt className='text-14 text-machine4-100'>{label}</dt>
    <dd className='text-16 font-medium text-black'>{value || '—'}</dd>
  </div>
)

type ReviewStepProps = {
  values: any
  fieldConfig: FieldsConfiguration
  isSubmitting: boolean
  hasError: boolean
  onBack: () => void
  onConfirm: (e?: any) => void
}

const ReviewStep = ({
  values,
  fieldConfig,
  isSubmitting,
  hasError,
  onBack,
  onConfirm
}: ReviewStepProps) => {
  const { formatMessage } = useIntl()
  return (
    <>
      <h2 className='font-Lora text-24 mb-4 font-bold text-black'>
        {formatMessage(messages.reviewHeadline)}
      </h2>
      <p className='font-Roboto text-16 mb-6 text-black'>
        {formatMessage(messages.reviewText)}
      </p>
      <dl className='font-Roboto mb-8 grid grid-cols-1 gap-4 text-black'>
        {Object.keys(fieldConfig).map((name) => (
          <ReviewRow
            key={name}
            label={fieldConfig[name].label}
            value={values[name]}
          />
        ))}
      </dl>
      {hasError && (
        <p role='alert' className='text-errorRed font-Roboto text-14 mb-4'>
          {formatMessage(messages.submissionFailed)}
        </p>
      )}
      <div className='flex flex-col gap-3 md:flex-row'>
        <Button variant='outline' onClick={onBack} isDisabled={isSubmitting}>
          {formatMessage(messages.edit)}
        </Button>
        <Button
          isLoading={isSubmitting}
          isDisabled={isSubmitting}
          onClick={onConfirm}
        >
          {formatMessage(messages.confirm)}
        </Button>
      </div>
    </>
  )
}

export default ReviewStep
